<template>
  <section class="app-main">
    <router-view />
  </section>
</template>

<script>
export default {
  name: 'AppMain'
}
</script>

<style lang="scss" scoped>
.app-main {
  min-height: 0;
  width: 100%;
  position: relative;
  overflow: hidden;
}
</style> 